import './pageHeader.scss';

import React, { useState } from 'react';
import { NavigationBar } from '../../components';
import phoneIconPath from '../../images/icons/phone-icon.svg';
import emailIconPath from '../../images/icons/email-icon.svg';
import youtubeIconPath from '../../images/icons/youtube-icon.svg';
import twitterIconPath from '../../images/icons/twitter-icon.svg';
import locationIconPath from '../../images/icons/location-icon.svg';
import facebookIconPath from '../../images/icons/facebook-icon.svg';
import instagramIconPath from '../../images/icons/instagram-icon.svg';
import logoIconPath from '../../images/icons/repair-pros-logo-icon.svg';
import { ContactUsModal } from '../contact-us-section/contactUsSection';

export const PageHeader: React.FC = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  return (
    <div className={'page-header'}>
      <div className={'page-header__top'}>
        <div className={'page-header__top__hours'}>
          <span>
            Opening Hours: Monday - Friday : <span>8:30AM - 5:00PM</span>
          </span>
        </div>
        <div className={'page-header__top__socials'}>
          <a href="https://facebook.com/">
            <img src={facebookIconPath} alt={'facebook icon'} />
          </a>
          <a href="https://youtube.com/">
            <img src={youtubeIconPath} alt={'youtube icon'} />
          </a>
          <a href="https://twitter.com/">
            <img src={twitterIconPath} alt={'twitter icon'} />
          </a>
          <a href="https://instagram.com/">
            <img src={instagramIconPath} alt={'instagram icon'} />
          </a>
        </div>
      </div>

      <div className={'page-header__middle'}>
        <div className={'page-header__middle__logo'}>
          <img src={logoIconPath} alt={'Repair Pros Logo'} />
        </div>

        <div className={'page-header__middle__details'}>
          <div className={'page-header__middle__details__item'}>
            <div className={'page-header__middle__details__item__left'}>
              <img src={phoneIconPath} alt={'phone icon'} />
            </div>
            <div className={'page-header__middle__details__item__right'}>
              <h2>Give Us A Call</h2>
              <p>+1 (876) 802-4187</p>
            </div>
          </div>

          <div className={'page-header__middle__details__item'}>
            <div className={'page-header__middle__details__item__left'}>
              <img src={locationIconPath} alt={'location icon'} />
            </div>
            <div className={'page-header__middle__details__item__right'}>
              <h2>Office Location</h2>
              <p>Russell Heights, Kingston, Jamaica</p>
            </div>
          </div>

          <div className={'page-header__middle__details__item'}>
            <div className={'page-header__middle__details__item__left'}>
              <img src={emailIconPath} alt={'email icon'} />
            </div>
            <div
              className={'page-header__middle__details__item__right'}
              style={{ cursor: 'pointer' }}
              onClick={openModal}
            >
              <h2>Email Us</h2>
              <p>prorequest@repairprosja.com</p>
            </div>
          </div>
        </div>
      </div>
      <div className={'page-header__navigation'}>
        <NavigationBar />
      </div>
      <ContactUsModal isOpen={modalIsOpen} onRequestClose={closeModal} />
    </div>
  );
};
